import React, { useState } from "react";
import TermsAndConditionsModal from "../terms-conditions-modal/termsAndConditionsModal";
import { makeStyles } from "@material-ui/core";
import { useTranslation } from "react-i18next";

export default function TermsAndConditionsButton() {
    const { t } = useTranslation();
    const [isOpen, setIsOpen] = useState(false);
    const classes = useStyles();

    return (
        <>
            <button
                className={classes.buttonReset}
                onClick={() => setIsOpen(!isOpen)}
            >
                {t("register.page.tosModal.title")}
            </button>
            <TermsAndConditionsModal visible={isOpen} handleClose={setIsOpen} />
        </>
    );
}

const useStyles = makeStyles((theme) => ({
    buttonReset: {
        WebkitAppearance: "none",
        borderRadius: 0,
        textAlign: "center",
        background: "none",
        boxShadow: "none",
        padding: 0,
        cursor: "pointer",
        border: "none",
        font: "inherit",
        fontSize: "0.8928571428571429rem",
        fontWeight: 400,
        lineHeight: 1.5,
        color: theme.palette.primary.contrastText,
        "&:hover": {
            textDecoration: "underline",
        },
    },
}));
